// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body.dialog, .dialog {
  overflow: hidden;
  overflow-wrap: break-word;
  word-wrap: break-word;
}

div.dialog {
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0,0,0,0.3);
  width: 100vw;
  height: 100vh;
  z-index: 1000;
}

.dialog--container {
  position: relative;
  display: inline-flex;
  flex-direction: column;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  z-index: 1001;
  width: 100%;
  max-width: 600px;
  max-height: 75vh;
  border: 1px solid #D9D9D9;
  border-radius: 8px;
  box-shadow: 0 24px 32px 0 rgba(12, 0, 51, 0.1);
  padding: 24px;
  background-color: #FFFFFF;
}

.dialog--header {
  margin: -24px -24px 0 -24px;
  padding: 24px;
  border-bottom: 1px solid #A0A5AE;
}

.dialog--title {
  font-weight: 600;
  font-size: 1.5rem;
}

.dialog--close {
  position: absolute;
  display: inline-block;
  right: 24px;
  width: 32px;
  height: 32px;
}

.dialog--body {
  overflow-y: auto;
  padding: 24px;
}

.dialog--actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: 0 -24px -24px -24px;
  padding: 24px;
  border-top: 1px solid #A0A5AE;
  text-align: right;
}

.dialog--actions.basic {
  border-top: none;
}

.dialog--actions > * {
  margin-right: 24px;
}

.dialog--actions > *:last-child {
  margin-right: 0;
}

`, "",{"version":3,"sources":["webpack://./src/app/uilib/dialog/dialog.component.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,iCAAiC;EACjC,YAAY;EACZ,aAAa;EACb,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;EACtB,QAAQ;EACR,SAAS;EACT,4CAA4C;EAC5C,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,8CAA8C;EAC9C,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,2BAA2B;EAC3B,aAAa;EACb,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB","sourcesContent":["body.dialog, .dialog {\r\n  overflow: hidden;\r\n  overflow-wrap: break-word;\r\n  word-wrap: break-word;\r\n}\r\n\r\ndiv.dialog {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  background-color: rgba(0,0,0,0.3);\r\n  width: 100vw;\r\n  height: 100vh;\r\n  z-index: 1000;\r\n}\r\n\r\n.dialog--container {\r\n  position: relative;\r\n  display: inline-flex;\r\n  flex-direction: column;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translateX(-50%) translateY(-50%);\r\n  z-index: 1001;\r\n  width: 100%;\r\n  max-width: 600px;\r\n  max-height: 75vh;\r\n  border: 1px solid #D9D9D9;\r\n  border-radius: 8px;\r\n  box-shadow: 0 24px 32px 0 rgba(12, 0, 51, 0.1);\r\n  padding: 24px;\r\n  background-color: #FFFFFF;\r\n}\r\n\r\n.dialog--header {\r\n  margin: -24px -24px 0 -24px;\r\n  padding: 24px;\r\n  border-bottom: 1px solid #A0A5AE;\r\n}\r\n\r\n.dialog--title {\r\n  font-weight: 600;\r\n  font-size: 1.5rem;\r\n}\r\n\r\n.dialog--close {\r\n  position: absolute;\r\n  display: inline-block;\r\n  right: 24px;\r\n  width: 32px;\r\n  height: 32px;\r\n}\r\n\r\n.dialog--body {\r\n  overflow-y: auto;\r\n  padding: 24px;\r\n}\r\n\r\n.dialog--actions {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n  margin: 0 -24px -24px -24px;\r\n  padding: 24px;\r\n  border-top: 1px solid #A0A5AE;\r\n  text-align: right;\r\n}\r\n\r\n.dialog--actions.basic {\r\n  border-top: none;\r\n}\r\n\r\n.dialog--actions > * {\r\n  margin-right: 24px;\r\n}\r\n\r\n.dialog--actions > *:last-child {\r\n  margin-right: 0;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
